module.exports = __webpack_public_path__ + "static/media/Frame_5.5fd8d66c.png";